import React, { Component } from 'react';
import { Dropdown, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { ReadOnlyContext } from './ReadOnlyContext';
import { CONTEXT_MENU_REGISTRY } from '../../../constants/contextMenuEntries';
import { SystemOnlyIcon, SystemOnlyPopup } from '../SystemOnlyBadge';

class ContextMenu extends Component {}

class ContextMenuItem extends Component {}

// ---------------------------
// Implementation

class ContextMenuImpl extends Component {
  render() {
    return (
      <Dropdown
        floating
        icon="ellipsis horizontal"
        pointing="top right"
        className="dot-context"
      >
        <Dropdown.Menu className="menu_custom">
          {this.props.children}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

/**
 * Determines whether a context menu item should be hidden.
 * Used both by ContextMenuItemImpl (per-row render) and by
 * Grid.createContextMenuEntry (to suppress the container when empty).
 */
export function isContextMenuItemHidden(itemProps, menuEntryKey, isReadOnly, rowItem) {
  const { isHiden, writeAction, contextMenuOptions } = itemProps;

  if (isHiden && isHiden(rowItem)) return true;

  if (isReadOnly) {
    const registryEntry = menuEntryKey ? CONTEXT_MENU_REGISTRY.get(menuEntryKey) : null;
    if (writeAction
      || (contextMenuOptions && contextMenuOptions.writeAction)
      || (registryEntry && registryEntry.writeAction)) {
      return true;
    }
  }

  return false;
}

class ContextMenuItemImpl extends Component {
  static contextType = ReadOnlyContext;

  onContextClick() {
    if (this.props.onClick) {
      this.props.onClick(this.props.id, this.props.item);
    }
  }

  render() {
    const {
      id,
      item,
      params,
      contextMenuOptions,
      url,
      target,
      disabledPopupProps,
      isDisabled,
      isHiden,
      writeAction,
      menuEntryKey,
      systemOnly,
      ...pprops
    } = this.props;

    const label = typeof this.props.label === "function" ? this.props.label(id, item) : this.props.label;
    // `systemOnly` is a boolean, or a function of the row when only some rows get the entry
    // because of system-level credentials.
    const isSystemOnly =
      typeof systemOnly === 'function' ? systemOnly(item) : !!systemOnly;
    const content = isSystemOnly ? (
      <>
        {label}
        <SystemOnlyIcon />
      </>
    ) : (
      label
    );
    const describe = (element) =>
      isSystemOnly ? <SystemOnlyPopup>{element}</SystemOnlyPopup> : element;

    const disabled =
      this.props.disabled || (isDisabled ? isDisabled(item) : false);

    if (isContextMenuItemHidden(this.props, menuEntryKey, this.context, item)) {
      return null;
    }

    const menuProps = {
      disabled,
      onClick: this.onContextClick.bind(this)
    };

    if (disabled && disabledPopupProps) {
      return (
        <Popup
          {...disabledPopupProps}
          trigger={
            <div
              role="option"
              aria-selected
              className="item"
              style={{ opacity: 0.45 }}
              aria-disabled="true"
            >
              {content}
            </div>
          }
        />
      );
    }

    if (contextMenuOptions) {
      if (!contextMenuOptions.getUrl) {
        return describe(
          <Dropdown.Item
            {...menuProps}
            as={'a'}
          >
            {content}
          </Dropdown.Item>
        );
      } else if (contextMenuOptions.target) {
        return describe(
          <Dropdown.Item
            {...menuProps}
            target={contextMenuOptions.target}
            as={'a'}
            href={contextMenuOptions.getUrl(item, params)}
          >
            {content}
          </Dropdown.Item>
        );
      } else {
        return describe(
          <Dropdown.Item
            {...menuProps}
            target={contextMenuOptions.target}
            as={Link}
            to={contextMenuOptions.getUrl(item, params)}
          >
            {content}
          </Dropdown.Item>
        );
      }
    }

    return describe(
      <Dropdown.Item {...pprops} {...menuProps}>
        {content}
      </Dropdown.Item>
    );
  }
}

// ---------------------------

ContextMenu.Impl = {};
ContextMenu.Impl.Container = ContextMenuImpl;
ContextMenu.Impl.Item = ContextMenuItemImpl;

ContextMenu.Item = ContextMenuItem;
export default ContextMenu;
